import React from 'react';
import { aggregatedClasses } from '@elliemae/ds-classnames';
import Paginator from './Paginator.js';
import PerPageDropdown from './PerPageDropdown.js';
import 'react-pagify';
import 'segmentize';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import 'memoize-one';
import '@elliemae/ds-utilities/utils';
import '@elliemae/ds-basic/form/ComboBox';

var PaginationControls = aggregatedClasses('div')('data-grid', 'controls-pagination');

var Pagination = function Pagination(_ref) {
  var paginated = _ref.paginated,
      _ref$pagination = _ref.pagination,
      pagination = _ref$pagination === void 0 ? {} : _ref$pagination,
      onPerPage = _ref.onPerPage,
      onPageSelect = _ref.onPageSelect,
      _ref$paginationStep = _ref.paginationStep,
      paginationStep = _ref$paginationStep === void 0 ? 5 : _ref$paginationStep,
      _ref$maxPerPage = _ref.maxPerPage,
      maxPerPage = _ref$maxPerPage === void 0 ? 10 : _ref$maxPerPage,
      _ref$minPerPage = _ref.minPerPage,
      minPerPage = _ref$minPerPage === void 0 ? 5 : _ref$minPerPage;
  var perPage = pagination.perPage;
  if (pagination && pagination.conditionalPagination === true && paginated.amount === 1) return null;
  return paginated.amount > 0 ? /*#__PURE__*/React.createElement(PaginationControls, null, /*#__PURE__*/React.createElement(PerPageDropdown, {
    max: maxPerPage,
    min: minPerPage,
    onChange: onPerPage,
    step: paginationStep,
    value: perPage
  }), /*#__PURE__*/React.createElement(Paginator, {
    onSelect: onPageSelect,
    pages: paginated.amount,
    pagination: pagination
  })) : null;
};

export { Pagination };
//# sourceMappingURL=Pagination.js.map
